import { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import { createPortal } from "react-dom";

const Marker = ({ map, feature, isActive, onClick, styles }) => {
  const { geometry } = feature;
  const lng = geometry.coordinates[0];
  const lat = geometry.coordinates[1];

  const markerRef = useRef();
  const [contentNode, setContentNode] = useState(() =>
    document.createElement("div")
  );

  useEffect(() => {
    if (!map) return;

    // Remove the old marker if it exists
    if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
    const newContentNode = document.createElement("div");
    setContentNode(newContentNode);

    markerRef.current = new mapboxgl.Marker(newContentNode)
      .setLngLat([lng, lat])
      .addTo(map);

    // Optionally, cleanup on unmount
    return () => {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = null; // Clear the reference to the marker
      }
    };
  }, [
    map,
    lng,
    lat,
    styles.markerShape,
    styles.markerColourActive,
    styles.markerColourNormal,
  ]);

  return (
    <>
      {createPortal(
        <div
          onClick={() => onClick(feature)}
          style={{
            display: "inline-block",
            cursor: "pointer",
            fontSize: `${styles.markerSize}px`,
            color: isActive
              ? styles.markerColourActive
              : styles.markerColourNormal,
            textAlign: "center",
          }}
        >
          <i className={styles.markerShape}></i>
        </div>,
        contentNode
      )}
    </>
  );
};

export default Marker;
